var _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdobePhotoshop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    "data-name": "Layer 1",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Photo Surface"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 232,
    x: 8,
    y: 12,
    fill: "#001e36",
    "data-name": "Outline no shadow",
    rx: 42
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31a8ff",
    d: "M58 182.88V74a1 1 0 011.12-1.12C67.23 72.67 76.8 72 89.28 72c14.72 0 25.52 3.07 32.4 9.68A32.6 32.6 0 01132 106.16q0 18.09-12.8 26.88T87 141.84L78 142v40.72A1.13 1.13 0 0176.72 184H59.28C58.43 184 58 183.63 58 182.88zM78 87.62V127s4.56-.18 10-.18q10.73 0 17.36-4.72T112 106.64q0-9.44-5.84-14.56T89.28 87c-1.81 0-3.6 0-5.36.08s-3.2.08-4.32.08S77.88 87.12 78 87.62zM198 158c0 12.25-8 18-8 18v-.06c-.48.47-1 .91-1.51 1.34Q180.23 184 166.16 184t-23-5.18a1.51 1.51 0 01-1-1.63V162.12a1 1 0 01.4-.89.54.54 0 01.72.08 36.41 36.41 0 0022.24 7.78q5.59 0 8.56-2a6.15 6.15 0 003-5.27 7.72 7.72 0 00-2.4-5.75q-2.4-2.36-9.44-5.11-12.81-5-17.84-10.78A20.48 20.48 0 01142 126a22.84 22.84 0 017.84-17.21q7.51-6.81 21.44-6.81 13 0 20 3.57c.53.32.8 1 .8 2.1v13.45c0 1.3-.48 1.62-1.44 1a34.53 34.53 0 00-18.72-5.67c-3.74 0-6.48.71-8.24 2.11a6.27 6.27 0 00-2.64 5 6.9 6.9 0 002.24 5.11q2.24 2.19 9.44 5.1 12.56 4.91 18 10.32l.09.09C194.54 147.59 198 152.31 198 158z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdobePhotoshop);
export default __webpack_public_path__ + "static/media/adobe-photoshop.5a9bf71e102fd7df7555ea70ef778bdd.svg";
export { ForwardRef as ReactComponent };